import i18n from '@/i18n'
import { eventService } from '@/services/event.service'
import { enterpriseService } from '@/services/enterprise.service'
import { mapActions } from 'vuex'
import { SnackbarStyle, EventHub } from '@/constants/constants'
import { DialogEventType } from "@/tools/dialog"
import EventTypeDialogDataTabComponent from './tabs/data/EventTypeDialogDataTabComponent.vue'
import EventTypeDialogEnterpriseTabComponent from './tabs/enterprise/EventTypeDialogEnterpriseTabComponent.vue'
import Vue from 'vue'

export default {
    name: 'EventTypeDialogComponent',
    components: {
        EventTypeDialogDataTabComponent,
        EventTypeDialogEnterpriseTabComponent
    },
    props: {
        // v-model injects the object to be edited into props.value
        model: {
            type: Object,
            required: true
        },
        update: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data: () => ({
        // model del formulario
        validForm: false,
        // reglas de validación
        validationRules: {
            required: (value) => !!value || `${i18n.t('required')}`,
            maxLength: (str, length) => !str || str.length <= length || `${i18n.t('error.strMaxLength', { length })}`
        },
        // tab seleccionada
        tab: null,
        // modelos de los tabs
        eventTypeDialogDataTab: {
            key: 'eventTypeDialogDataTab',
            tab: i18n.t('eventType.editDialog.tabs.data'),
            tooltip: i18n.t('eventType.editDialog.tabs.dataTooltip'),
            icon: 'mdi-form-textbox',
            content: {
                _uid: 'oLkbANttlu',
                component: 'EventTypeDialogDataTabComponent',
                headline: 'EventTypeDialogDataTabComponent'
            },
            model: {
                name: { es: null, en: null, pt: null },
                color: '#ff0000',
                comment: null,
                update: false
            },
            validForm: false
        },
        eventTypeDialogEnterpriseTab: {
            key: 'eventTypeDialogEnterpriseTab',
            tab: i18n.t('eventType.editDialog.tabs.enterprises'),
            tooltip: i18n.t('eventType.editDialog.tabs.enterprisesTooltip'),
            icon: 'mdi-office-building',
            content: {
                _uid: 'oLkbANttlv',
                component: 'EventTypeDialogEnterpriseTabComponent',
                headline: 'EventTypeDialogEnterpriseTabComponent'
            },
            model: {
                enterprisesData: [],
                enterprises: [],
                global: false,
                update: false
            },
            validForm: false
        },
        tabs: [],
        // flag para resetear validaciones en los formularios
        resetForms: false
    }),
    computed: {
        disabledButton () {
            return !this.eventTypeDialogDataTab.validForm || !this.eventTypeDialogEnterpriseTab.validForm
        }
    },
    created() {
    },
    mounted() {
        // pusheo los tabs
        this.tabs.push(this.eventTypeDialogDataTab)
        this.tabs.push(this.eventTypeDialogEnterpriseTab)
    },
    methods: {
        /**
         * actions del snackbar
         */
        ...mapActions('snackbar', [
            'showSnackbar',
            'closeSnackbar'
        ]),
        /**
         * actions del dialog
         */
        ...mapActions('dialog', [
            'openDialog',
            'closeDialog'
        ]),
        /**
         * actions del breadcrumb
         */
        ...mapActions('breadcrumbs', [
            'pullBread',
            'pushBread'
        ]),
        /**
         * Resetea los campos del formulario de creación/actualización
         */
        resetFields() {
            // tab de datos personales
            this.eventTypeDialogDataTab.model.name = { es: null, en: null, pt: null },
            this.eventTypeDialogDataTab.model.color = '#ff0000',
            this.eventTypeDialogDataTab.model.comment = null
            
            // tab de empresas
            this.eventTypeDialogEnterpriseTab.model.enterprises = []
            this.eventTypeDialogEnterpriseTab.model.enterprisesData = []
            this.eventTypeDialogEnterpriseTab.model.global = false

            // updates
            this.eventTypeDialogDataTab.model.update = false
            this.eventTypeDialogEnterpriseTab.model.update = false

            // para limpiar las validaciones en los formularios
            this.resetForms = true
            const that = this
            Vue.nextTick(function() {
                that.resetForms = false
            })
        },
        /**
         * Click fuera del dialog
         */
        clickOutside() {
            this.cancel()
        },
        /**
         * Cancelar
         */
        cancel() {
            this.pullBread(DialogEventType)
            this.resetFields()
        },
        /**
         * Guardar
         */
        save() {
            const eventTypeDto = this.getEventTypeDto()
            if (this.update) {
                eventService.updateEventType(eventTypeDto).then(() => {
                    this.showSnackbar({
                        visible: true,
                        text: this.$t('eventType.successUpdateMessage'),
                        timeout: 6000,
                        style: SnackbarStyle.SUCCESS
                    })
                    this.resetFields()
                    this.$emit('commitEventType')
                    this.cancel()
                })
            } else {
                eventService.createEventType(eventTypeDto).then((insertedId) => {
                    this.showSnackbar({
                        visible: true,
                        text: this.$t('eventType.successCreateMessage'),
                        timeout: 6000,
                        style: SnackbarStyle.SUCCESS
                    })
                    this.resetFields()
                    this.$emit('commitEventType')
                    this.cancel()
                    this.$eventBus.$emit(EventHub.COMMIT_EVENT_TYPE, insertedId)
                })
            }
        },
        /**
         * Genera el DTO para actualizar / crear un tipo de evento
         */
        getEventTypeDto() {
            const result = {
                name: this.eventTypeDialogDataTab.model.name,
                color: this.eventTypeDialogDataTab.model.color,
                comment: this.eventTypeDialogDataTab.model.comment,
                enterprises: this.eventTypeDialogEnterpriseTab.model.enterprises,
                global: this.eventTypeDialogEnterpriseTab.model.global,
            }
            if (this.update) {
                result._id = this.model._id
            }
            return result
        }
    },
    watch: {
        model: {
            deep: true,
            immediate: true,
            handler: async function (newModel) {
                if (newModel) {
                    // tab de datos personales
                    this.eventTypeDialogDataTab.model.name = newModel.name,
                    this.eventTypeDialogDataTab.model.color = newModel.color,
                    this.eventTypeDialogDataTab.model.comment = newModel.comment
                    
                    // tab de empresas
                    this.eventTypeDialogEnterpriseTab.model.enterprises = newModel.enterprises
                    this.eventTypeDialogEnterpriseTab.model.enterprisesData = await enterpriseService.getAllForSelectorUserABM(newModel.enterprises)
                    this.eventTypeDialogEnterpriseTab.model.global = newModel.global

                    // updates
                    this.eventTypeDialogDataTab.model.update = newModel.update
                    this.eventTypeDialogEnterpriseTab.model.update = newModel.update
                }
            }
        }
    }
}
